<template>
  <div style="margin:20px">
    <FiPageRail title="OTP - Nightly Report History" />
    <div style="font-size: 20px; font-weight: bold; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>

      <span v-if="route_options.length > 0">
        &nbsp;&nbsp;|&nbsp;&nbsp;Routes:
          &nbsp;<b-form-select v-model="route_filter" :options="route_options" style="font-size: 18px; font-weight: bold; width:200px"/>
        &nbsp;<b-button size="md" @click="load_data()">Get Results</b-button>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        &nbsp;<b-button size="md" @click="send_report(false, false)">Email Report To Me</b-button>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        &nbsp;<b-button size="md" @click="send_report(true, false)">ReRun & Email Me</b-button>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        &nbsp;<b-button size="md" @click="send_report(true, true)">ReRun & Email All</b-button>
      </span>
      <div v-else>
        &nbsp;&nbsp;|&nbsp;&nbsp;loading routes&nbsp;&nbsp;<b-spinner style="width: 2rem; height: 2rem;" label="Loading..."></b-spinner>
      </div>
      <div v-if="summary.total_cnt" style="margin-left: 40px; min-width: 230px; max-width:230px;" class="totals">
        <span v-if="summary.total_cnt == items.length">{{summary.total_cnt}} results</span>
        <span v-else>{{items.length}} of {{summary.total_cnt}} results</span>
      </div>
    </div>
    <br/>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="Stop" slot-scope="row">
          {{row.item.Stop}}
          <span v-if="row.item.StopID">[{{row.item.StopID}}]</span>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

  </div>

</template>
<script>
import {api_url, get_otp_report, get_route_patterns} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'report_otp',

  components: {
  },

  data() {
    return {
      route_options: [],
      items: [],
      items_full: [],
      summary: [],
      details_fromDate: justDate(moment().subtract(1, 'days')),
      route_filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      loading: false,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
      fields_all: [],
      fields: [
        { key: 'Trip', sortable: true},
        { key: 'Asset', sortable: true},
        { key: 'DriverName', sortable: true},
        { key: 'Stop', sortable: true},
        { key: 'Type', sortable: true},
        { key: 'Scheduled', sortable: true},
        { key: 'Actual', sortable: true},
        { key: 'StopTime', sortable: true},
        { key: 'StopDuration', sortable: true},
        { key: 'MinimumSpeed', label:'Min Speed', sortable: true},
        { key: 'Performance', sortable: true},
        { key: 'Minutes', sortable: true},
        { key: 'Passengers On', label:'Pax On', sortable: true},
        { key: 'Passengers Off', label: 'Pax Off', sortable: true},
        { key: 'Cash Collected', label: 'Cash', sortable: true}
      ]
    }
  },
  async created() {
    await this.check_features()
  },
  methods: {
    async check_features() {
      this.summary = {}
      this.items = []
      this.items_full = []
      await this.load_routes()
    },
    async load_routes() {
      const {value: {data = []}} = await get_route_patterns(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.route_options = data
      this.route_filter = data[0]['value']
    },
    showDetails(item) {
      item.isVisible = !item.isVisible;
      this.$forceUpdate();
    },
    async load_data(){

      this.loading = true

      const {value: {data = []}} = await get_otp_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),this.route_filter)
      this.summary = data.summary
      moment.tz.setDefault(this.summary.timezone)
      this.items = data.results
      this.items_full = data.results

      this.loading = false

    },
    async send_report(rerun, send_to_all){
      
      this.$emit('showAlert', 'Processing your report request - takes ~10m to run', 'info', 30000)

      let otp_api_url = api_url + "bookings";

      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${otp_api_url}/reports/otp/send`,
          {
            tenant: this.user.tenant,
            route_filter: this.route_filter,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            send_to_all: send_to_all,
            rerun: rerun,
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/json'
            },
            responseType: 'text'
          }
      ).then((response) => {
        this.$emit('showAlert', 'Report Sent!', 'success', 3500)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'no data found', 'warning', 3500)
      })
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(27, 'days'));
    }
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
